<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Livro de Ocorrências</h2>
      <p>
        Registre e acompanhe ocorrências.
      </p>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-img
        class="d-none d-md-block"
        fluid
        :src="require('@/assets/images/pages/calendar-illustration.png')"
      />
    </b-col>
    <b-col
      cols="12"
      class="my-2 text-center"
    >
      <router-link to="/ocorrencia/new">
        <b-button
          variant="outline-primary"
          class="w-100"
        >
          <feather-icon icon="PlusIcon" />
          Nova Ocorrência
        </b-button>
      </router-link>
    </b-col>
    <b-col
      cols="12"
      class="mt-0"
    >
      <list-mural-aviso />
    </b-col>
  </b-row>
</template>

<script>
import ListMuralAviso from './ListOcorrencias.vue'

export default {
  components: {
    ListMuralAviso,
  },
}
</script>
